<template>
    <BreadCrumb PageTitle="Liste des contrats ayant des arrièrés" />
    <ListeArrieresContrat/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    //import ListeArrieresContrat from "../../components/ArriresContrat/ListeArrieresContrat.vue";
    import ListeArrieresContrat from "@/components/ArrieresContrat/ListeArrieresContrat.vue";
  
    export default defineComponent({
      name: "ListeTarifAnnuelPage",
      components: {
        BreadCrumb,
        ListeArrieresContrat,
      },
    });
  </script>